var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11126_1566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.49994 16.5V3.00003C4.49994 2.60221 4.65797 2.22067 4.93928 1.93937C5.22058 1.65807 5.60211 1.50003 5.99994 1.50003H11.9999C12.3978 1.50003 12.7793 1.65807 13.0606 1.93937C13.3419 2.22067 13.4999 2.60221 13.4999 3.00003V16.5M4.49994 16.5H13.4999M4.49994 16.5H2.99994C2.60211 16.5 2.22058 16.342 1.93928 16.0607C1.65797 15.7794 1.49994 15.3979 1.49994 15V10.5C1.49994 10.1022 1.65797 9.72067 1.93928 9.43937C2.22058 9.15807 2.60211 9.00003 2.99994 9.00003H4.49994M13.4999 16.5H14.9999C15.3978 16.5 15.7793 16.342 16.0606 16.0607C16.3419 15.7794 16.4999 15.3979 16.4999 15V8.25003C16.4999 7.85221 16.3419 7.47067 16.0606 7.18937C15.7793 6.90807 15.3978 6.75003 14.9999 6.75003H13.4999M7.49994 4.50003H10.4999M7.49994 7.50003H10.4999M7.49994 10.5H10.4999M7.49994 13.5H10.4999",
    stroke: "#141414",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11126_1566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.a3bf6246c9cd12594bce6e05c195bc3d.svg";
export { ForwardRef as ReactComponent };